export const MAIN_COLOR_STRING = '#01c7d4';
export const MAIN_TITLE_FONTSIZE_STRING = '20px';
export const ACCESS_TOKEN_NAME = 'access';
export const LANG_NAME = 'lang';
export const REFRESH_TOKEN_NAME = 'refresh';
export const JSON_CONTENT_TYPE = 'application/json';
export const FORM_DATA_CONTENT_TYPE = 'form-data';
export const WARNING_DATA_CONTENT_TYPE = 'warning-data';
export const API_REQUEST_TIMEOUT_MILLISECONDS = 500_000;
export const API_REQUEST_TIMEOUT_MILLISECONDS_ERROR_STATUS = -10;
export const API_STATUS_PROBLEM =
  'Произошла ошибка, это все что мы знаем... Попробуйте повторить запрос позже';
export const SECRET_KEY_ADMIN = 'nurlat';
export const SECRET_KEY_CONTENT = 'nurlat-key';

export const BEGIN_BUTTON_NAME = 'Назад';
export const NEXT_BUTTON_NAME = 'Далее';
export const BACK_BUTTON_NAME = 'Назад';
export const END_BUTTON_NAME = 'Завершить';
export const PREV_SLIDE_BUTTON_NAME = 'Предыдущий слайд';
export const NEXT_SLIDE_BUTTON_NAME = 'Следующий слайд';

export const VIEW_TYPE_ALL_SLIDE = 0;
export const VIEW_TYPE_ONE_SLIDE = 1;

export const BIG_FONT_SIZE = '18px';
export const NORM_FONT_SIZE = '14px';
export const SMALL_FONT_SIZE = '10px';

export const BIG_VIDEO_SIZE = '1080p';
export const NORM_VIDEO_SIZE = '720p';
export const SMALL_VIDEO_SIZE = '480p';

export const SECTION_NAME = 'section';
export const LECTION_NAME = 'lection';

export const USER_NAME = 'username';
export const IMAGE_TYPE = 0;
export const AUDIO_TYPE = 1;
export const ANNOTATION_TYPE = 2;

export const ACCEPTED_INPUT_FORM_FILE_TYPES = '.png, .mp4';
export const ACCEPTED_INPUT_WARNING_FILE_TYPES = '.png, .mp4';

export const ACCEPTED_INPUT_FORM_FILE_TYPES_MP3 = '.mp3';
export const ACCEPTED_INPUT_WARNING_FILE_TYPES_MP3 = '.mp3';

export const MAX_UPLOAD_FILES_COUNT = 50;
export const MAX_UPLOAD_FILES_SIZE = 1000000000;

export const SPACE_IMAGE = 1;
export const SPACE_CONSPECT = 2;
export const SPACE_IMAGE_LINK = 3;
export const SPACE_TERMIN = 4;
export const SPACE_DESIGN = 5;
export const SPACE_AUDIO = 6;
export const SPACE_TABLE = 7;
export const SPACE_CLOUD = 9;

export const IMAGE_TYPE_ONE = 0;
export const IMAGE_TYPE_CROP = 1;
export const IMAGE_TYPE_MANY = 2;
export const IMAGE_TYPE_BASE_AND_SELECT = 3;
export const IMAGE_TYPE_VIDEO = 4;
export const IMAGE_TYPE_ZOOM = 5;
export const IMAGE_TYPE_ZOOM_WITH_BLACK = 6;
export const IMAGE_TYPE_ZOOM_VIDEO = 7;
export const IMAGE_TYPE_BASE_AND_SELECT_WITH_BLACK = 8;
export const IMAGE_TYPE_VIDEO_POSTER = 100;

export const LIGHT_THEME = 0;
export const DARK_THEME = 1;
export const SYSTEM_THEME = 2;

export const TABLE_VIEW_CHANGE_WIDTH_WINDOW = 700;

export const WINDOW_V = 0;
export const WINDOW_H = 1;

export const DESCTOP_CHANGE = 960;
export const DESCTOP_TWO_CHANGE = 1250;
export const DESCTOP_TWO_BUTTON_CHANGE = 1450;

export const TG_CHANAL = 'https://t.me/uchimed_chan';
export const VK_CHANAL = 'https://vk.com/learn_anat';
export const OFERTA_URL = 'https://uchianat.ru/api/offer.html';
export const POL_SOGL_URL = 'https://uchianat.ru/api/useragr.html';
export const SOGL_OBR_URL = 'https://uchianat.ru/api/persdata.html';
export const POLIT_CONFID_URL = 'https://uchianat.ru/api/confid.html';
export const APPLE_SHOP = 'https://apps.apple.com/ru/app/учи-анат/id1530684725';
export const ANDROID_SHOP =
  'https://play.google.com/store/apps/details?id=com.learnanat';
export const HUAWEI_SHOP =
  'https://appgallery.cloud.huawei.com/ag/n/app/C109705735';

// export const TG_SUPPORT = 'https://t.me/uchi_med';
export const TG_SUPPORT = 'tg://resolve?domain=uchi_med';

// export const TG_SUPPORT_PURCAHSE = 'https://t.me/uchi_med_bot?start=';
export const TG_SUPPORT_PURCAHSE = 'tg://resolve?domain=uchi_med_bot&start=';

export const MAX_SUPPORT =
  'https://max.ru/u/f9LHodD0cOKKAbD2FplXO2w1XWd6P2DZ4DBaw7Eykex-F2QkXQObVgTeUEE';
export const MAX_SUPPORT_PURCAHSE = 'https://max.ru/id1655488623_bot?start=';

export const VK_SUPPORT = 'https://vk.me/learn_anat';
export const VK_SUPPORT_PURCAHSE = 'https://vk.me/learn_anat';
